import React from 'react';
import { ACCENT_TOKENS } from '../resources/registry';
import { ASSETS, PRINT_SPECS, ORDERING_NOTES } from './assetsRegistry';
import './assets-library.css';

function AssetCard({ asset }) {
  const accent = ACCENT_TOKENS[asset.accent] || ACCENT_TOKENS.magenta;
  return (
    <div className="resource-card resource-card--static">
      <div
        className="resource-card__cover"
        style={{ background: accent.bg, color: accent.text }}
      >
        <span className="resource-card__number">{asset.number}</span>
        <span className="resource-card__category">{asset.category}</span>
      </div>
      <div className="resource-card__body">
        <h3 className="resource-card__title">{asset.title}</h3>
        <p className="resource-card__summary">{asset.summary}</p>
        <div className="assets-library__downloads">
          {asset.files.map((file) => (
            <a
              key={file.href}
              href={file.href}
              download={file.filename}
              className="win95-btn win95-btn--compact"
            >
              ↓ {file.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function AssetsLibrary() {
  return (
    <div className="resource-view">
      <section className="forms-library__heading assets-library__heading">
        {/* Pane header — chrome band replaces the old eyebrow + display title */}
        <div className="win95-pane-header" style={{ marginBottom: 16 }}>
          <div>
            <div className="win95-pane-header__context">Director tools</div>
            <h2 className="win95-pane-header__title">Assets library</h2>
          </div>
          <div className="win95-pane-header__stats">
            <div className="win95-statpanel">
              <div className="win95-statpanel__label">Assets</div>
              <div className="win95-statpanel__figure">{ASSETS.length}</div>
            </div>
          </div>
        </div>
        <p className="forms-library__lede">
          Print-ready files for chapter operations. Reusable giant checks for
          award presentations, ready to download as PDF or SVG and hand off
          to your local printer.
        </p>

        <div className="resource-grid">
          {ASSETS.map((asset) => (
            <AssetCard key={asset.id} asset={asset} />
          ))}
        </div>

        <div className="assets-library__notes">
          <fieldset className="win95-groupbox assets-library__notes-col">
            <legend>Print specifications</legend>
            <p className="assets-library__notes-lede">
              Two sizes we&rsquo;ve had printed in the past. Send these specs
              straight to your printer.
            </p>
            <ul className="assets-library__spec-list">
              {PRINT_SPECS.map((spec) => (
                <li key={spec.size} className="assets-library__spec">
                  <span className="assets-library__spec-size">{spec.size}</span>
                  <span className="assets-library__spec-detail">{spec.detail}</span>
                </li>
              ))}
            </ul>
          </fieldset>

          <fieldset className="win95-groupbox assets-library__notes-col">
            <legend>Ordering notes</legend>
            <ul className="assets-library__bullets">
              {ORDERING_NOTES.map((note, i) => (
                <li key={i}>{note}</li>
              ))}
            </ul>
          </fieldset>
        </div>
      </section>
    </div>
  );
}
